import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import Env from '../../../env/env';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

interface NeighborsQuery {
  count: number;
  results: string[][];
  columns: [];
}

@Component({
  selector: 'app-neighbors-table',
  templateUrl: './neighbors-table.component.html',
  styleUrls: ['./neighbors-table.component.css']
})
export class NeighborsTableComponent implements OnInit {
  @Input() id: string;
  @Input() case: string;
  @Input() src: string;
  @Input() type: string;

  neighborsColumns: string[];
  displayedColumns: string[];
  neighborsSource: MatTableDataSource<string[]>;
  @ViewChild(MatSort, {static: true}) neighborsSort: MatSort;
  @ViewChild(MatPaginator, {static: true}) neighborsPaginator: MatPaginator;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.http.get<NeighborsQuery>(Env.apiUrl + `/vma/neighbors?id=${this.id}&case=${this.case}&type=${this.type}`)
      .subscribe((data) => {
        console.log('Start loading');
        this.neighborsColumns = data.columns;
        this.displayedColumns = [...Array(this.neighborsColumns.length).keys()].map(x => x.toString());

        this.neighborsSource = new MatTableDataSource(data.results);
        this.neighborsPaginator = this.neighborsSource.paginator;
        this.neighborsSort = this.neighborsSource.sort;
        console.log('End loading');
      });
  }

  renderRow(row: string) {
    if (row && (row.startsWith('http://') || row.startsWith('https://'))) {
      return `<a href="${row}" target="_blank">${row}</a>`;
    }
    return row;
  }
}
